const MILLISECOND_TIMESTAMP_THRESHOLD = 1_000_000_000_000;

export function timestampValue(value) {
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return 0;

    return value < MILLISECOND_TIMESTAMP_THRESHOLD ? value * 1_000 : value;
  }
  if (typeof value !== 'string' || !value) return 0;

  const parsedValue = Date.parse(value);
  return Number.isNaN(parsedValue) ? 0 : parsedValue;
}

export const readyWidgetPreviewVersion = (run) => (run?.preview?.state === 'ready' ? run.preview.version || null : null);

// The candidate preview the studio keeps on screen for a chat's current turn: the
// turn's own ready preview, else `heldPreview` — the last candidate this client showed.
// A revision replaces the whole turn before its own preview exists, so without the hold
// every build would swap the iframe to the stale stable runtime and back. The held
// worker stays deployed exactly that long: preview cleanup runs only once a newer
// preview is ready or the run publishes, and publication ends the hold because the
// stable runtime then serves the promoted version. Null means "show the stable runtime".
export function widgetStudioGenerationPreview(turn, heldPreview = null) {
  const builderStateName = turn?.builder_state?.state;
  if (builderStateName === 'published' || builderStateName === 'unpublished') return null;
  if (turn?.preview?.state === 'ready' && turn.preview.url) {
    return { url: turn.preview.url, height: turn.preview.height || null };
  }
  return heldPreview;
}

export const widgetVersionLabel = ({ latestVersion, liveVersion }) => {
  if (!latestVersion) return null;
  if (latestVersion === liveVersion) return `v${latestVersion} live`;
  if (liveVersion) return `v${latestVersion} draft · v${liveVersion} live`;

  return `v${latestVersion} draft`;
};
